import React from 'react';
import {
  FileText,
  FileSpreadsheet,
  Image as ImageIcon,
  FileVideo,
  File as FileIcon,
} from 'lucide-react';
import { getFileServeUrl } from '@auw/api-client';
import type { FileAttachment, WorkspaceFile } from '@auw/workspace-utils';

export function workspaceFileToAttachment(workspaceFile: WorkspaceFile): FileAttachment {
  const serveUrl = getFileServeUrl(workspaceFile.file_id);
  return {
    id: workspaceFile.file_id,
    name: workspaceFile.original_name,
    type: workspaceFile.mime_type,
    size: workspaceFile.size_bytes,
    previewUrl: serveUrl,
    file: new File([], workspaceFile.original_name),
    remoteUrl: serveUrl,
  };
}

export function getWorkspaceFileIcon(mime: string, name: string): React.ReactNode {
  if (mime.startsWith('image/')) return React.createElement(ImageIcon, { size: 14 });
  if (mime.startsWith('video/')) return React.createElement(FileVideo, { size: 14 });
  const ext = name.split('.').pop()?.toLowerCase() || '';
  if (['xls', 'xlsx', 'csv'].includes(ext)) {
    return React.createElement(FileSpreadsheet, { size: 14 });
  }
  if (['pdf', 'doc', 'docx', 'hwp', 'hwpx', 'txt', 'md'].includes(ext)) {
    return React.createElement(FileText, { size: 14 });
  }
  return React.createElement(FileIcon, { size: 14 });
}

export function createSharePassword(length = 10): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
  let out = '';
  for (let i = 0; i < length; i += 1) {
    out += chars[Math.floor(Math.random() * chars.length)];
  }
  return out;
}

export function createGroupId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `group_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function extractHttpStatus(err: unknown): number | null {
  if (!(err instanceof Error)) return null;
  const matched = err.message.match(/HTTP\s+(\d+)/i);
  if (!matched) return null;
  const code = Number(matched[1]);
  return Number.isFinite(code) ? code : null;
}
